'use client';
import Button from '@/components/Button';
import useBrand from '@/hooks/useBrand';
import { authorize } from '@/services/AuthorizationService';
import { Brand } from '@/types/Brand';
import { useEffect } from 'react';
import styles from './page.module.css';

export default function Page() {
  const brand = useBrand();
  useEffect(() => {
    authorize((brand.get() ?? '') as Brand);
  }, []);

  return (
    <div className={styles['content']}>
      <p>
        Bienvenue sur l&apos;application d&apos;administration PPID. Cliquez
        ci-dessous pour vous connecter
      </p>
      <Button disabled loading={true}>
        login
      </Button>
    </div>
  );
}
